"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _editor = _interopRequireDefault(require("@insided/deprecated-preact-components/editor"));

var _PinnedReply = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/Post/PinnedReply"));

var _BestAnswer = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/Post/BestAnswer"));

var _Poll = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/Post/Poll"));

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PostContent = function PostContent(_ref) {
  var _topic$poll;

  var showEditor = _ref.showEditor,
      attachments = _ref.attachments,
      isLoading = _ref.isLoading,
      editorErrors = _ref.editorErrors,
      handleOpeningPostChange = _ref.handleOpeningPostChange,
      disableFileAttachments = _ref.disableFileAttachments,
      _onCancel = _ref.onCancel,
      _onChange = _ref.onChange,
      pinnedReply = _ref.pinnedReply,
      topic = _ref.topic,
      pollVotes = _ref.pollVotes,
      answeredPoll = _ref.answeredPoll,
      pollSelectionLoading = _ref.pollSelectionLoading,
      handlePollAnswer = _ref.handlePollAnswer,
      translatedBestAnswerText = _ref.translatedBestAnswerText,
      translatedPinnedReplyText = _ref.translatedPinnedReplyText,
      isTranslationInProgress = _ref.isTranslationInProgress,
      translatedTopicContent = _ref.translatedTopicContent;
  return (0, _preact.h)("div", null, showEditor ? (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref2) {
    var lock = _ref2.lock,
        unlock = _ref2.unlock;
    return (0, _preact.h)("div", {
      className: (0, _classnames.default)('post__content', 'post__edit', 'qa-topic-post-edit')
    }, (0, _preact.h)(_editor.default, {
      disableFileAttachments: disableFileAttachments,
      data: translatedTopicContent,
      attachments: attachments,
      canHavePoll: false,
      isLoading: isLoading,
      errors: editorErrors,
      onSubmit: function onSubmit() {
        unlock();
        handleOpeningPostChange();
      },
      onCancel: function onCancel() {
        unlock();

        _onCancel();
      },
      onChange: function onChange(content, attachments) {
        _onChange(content, attachments);

        lock(content, topic.content);
      },
      profile: "openingPost"
    }));
  }) : (0, _preact.h)("div", {
    className: (0, _classnames.default)('topic-view-content-wrapper', {
      'translation-loading': isTranslationInProgress
    })
  }, (0, _preact.h)(_Content.default, {
    content: translatedTopicContent !== null && translatedTopicContent !== void 0 ? translatedTopicContent : '',
    className: (0, _classnames.default)('post__content', 'qa-topic-post-content', 'post__content--new-editor')
  }), pinnedReply && (0, _preact.h)(_PinnedReply.default, {
    pinnedReply: _objectSpread(_objectSpread({}, pinnedReply), {}, {
      content: translatedPinnedReplyText !== null && translatedPinnedReplyText !== void 0 ? translatedPinnedReplyText : ''
    })
  }), topic.bestAnswer && (0, _preact.h)(_BestAnswer.default, {
    bestAnswer: _objectSpread(_objectSpread({}, topic.bestAnswer), {}, {
      pagetext: translatedBestAnswerText !== null && translatedBestAnswerText !== void 0 ? translatedBestAnswerText : ''
    })
  }), ((_topic$poll = topic.poll) === null || _topic$poll === void 0 ? void 0 : _topic$poll.poll) && !showEditor && (0, _preact.h)(_Poll.default, {
    poll: topic.poll.poll,
    pollVotes: pollVotes,
    answeredPoll: answeredPoll,
    pollSelectionLoading: pollSelectionLoading,
    handlePollSelection: handlePollAnswer
  })));
}; // export default PostContent


var _default = (0, _OnDemandTranslations.withOnDemandTranslationProps)(PostContent, ['isTranslationInProgress', 'translatedTopicContent', 'translatedBestAnswerText', 'translatedPinnedReplyText']);

exports.default = _default;